import React from "react";

export const Breadcrumb = ({ text, title }) => {
  return (
    <section className="breadcrumb-area breadcrumb-bg">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb-content">
              <h1 className="title">{title}</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  {/* <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    {text}
                  </li> */}
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="breadcrumb-shape-wrap">
        <img
          src="/images/home/red_ball.png"
          alt=""
          className="breadcrumb-red-ball"
        />
        <img src="/images/home/dots.png" alt="" />
      </div>
    </section>
  );
};
